(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["obd-pack-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-obd-pack-upgrade]') : null;
    if (!button) return;
    const picker = button.closest('variant-picker');
    const input = picker?.querySelector('.obd-pack-picker input[value="100"]');
    if (!(input instanceof HTMLInputElement) || input.getAttribute('aria-disabled') === 'true') return;
    input.click();
    input.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["obd-product-consistency"] && !Shopify.designMode) return;
  try {
    (() => {
    const styleId = 'obd-cart-consistency';
    const css = `
      #UpcartPopup {
        font-family: var(--font-body--family, Manrope, sans-serif) !important;
        --upcart-internal-global-button-background-color: #0145de !important;
        --upcart-internal-global-button-text-color: #ffffff !important;
        --upcart-internal-global-button-text-hover-color: #ffffff !important;
        --upcart-internal-global-button-border-radius: 6px !important;
      }
      #UpcartPopup :is(button, input, select) {
        font-family: inherit !important;
      }
      #UpcartPopup a[href*="/cart/c/"],
      #UpcartPopup a[href*="/checkout"] {
        min-height: 50px !important;
        border-radius: 6px !important;
        background: #0145de !important;
        color: #ffffff !important;
        font-family: inherit !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 1.4 !important;
      }
      #UpcartPopup a[href*="/cart/c/"]:hover,
      #UpcartPopup a[href*="/checkout"]:hover {
        background: #053cb8 !important;
        color: #ffffff !important;
      }
      #UpcartPopup a[href*="/cart/c/"]:focus-visible,
      #UpcartPopup a[href*="/checkout"]:focus-visible {
        outline: 2px solid #0145de;
        outline-offset: 3px;
      }
    `;
    const attach = () => {
      const root = document.getElementById('upCart')?.shadowRoot;
      if (!root) return false;
      if (!root.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        root.append(style);
      }
      return true;
    };
    const start = () => {
      if (attach()) return;
      let attempts = 0;
      const timer = setInterval(() => {
        attempts += 1;
        if (attach() || attempts >= 40) clearInterval(timer);
      }, 500);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', start);
  })();
(() => {
  if (window.obdStorageBuddyAutoFit) return;
  window.obdStorageBuddyAutoFit = true;
  const offerSelector = '.axe-main[data-checkbox-id="107546"]';
  const styleSelector = 'input[name^="Box Style-"][name$="-9058428158070"]:checked';
  const state = { fit: null, pack: '15', value: null, select: null, checkbox: null, checked: null };
  let syncing = false;
  let queued = false;
  let readinessRetries = 0;
  const packOf = option => option?.textContent.trim().match(/^\d+/)?.[0];
  function sync() {
    if (syncing) return;
    const offer = document.querySelector(offerSelector);
    const select = offer?.querySelector('.axe-select');
    const checkbox = offer?.querySelector('.axe-input');
    const scope = offer?.closest('.shopify-section') || document;
    const style = scope.querySelector(styleSelector)?.value;
    const fit = style === 'Single Row / 3-Pack' ? 'Standard / Single-Wall Box'
      : style === '5-Row / 5000 Count / 6-Pack' ? 'Thick / Double-Wall Box' : null;
    if (!select || !checkbox || !fit) return;
    syncing = true;
    try {
      const options = [...select.options].filter(option => !option.disabled);
      const fitChanged = fit !== state.fit;
      const selectReplaced = select !== state.select;
      if (state.fit === null) state.pack = packOf(select.selectedOptions[0]) || '15';
      const matching = options.filter(option => option.textContent.includes(fit));
      const desired = fitChanged
        ? matching.find(option => packOf(option) === state.pack) || matching[0]
        : selectReplaced
          ? options.find(option => option.value === state.value)
            || matching.find(option => packOf(option) === state.pack) || matching[0]
          : options.find(option => option.value === select.value);
      if ((fitChanged || selectReplaced) && !desired) return;
      state.fit = fit;
      state.select = select;
      if (desired) {
        state.value = desired.value;
        state.pack = packOf(desired) || state.pack;
        if (select.value !== desired.value || checkbox.value !== desired.value) {
          select.value = desired.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          // Axe can attach its change listener after inserting the offer.
          if (checkbox.value !== desired.value && readinessRetries++ < 20) {
            setTimeout(schedule, 250);
          } else if (checkbox.value === desired.value) readinessRetries = 0;
        }
      }
      if (state.checked === null) state.checked = checkbox.checked;
      if (checkbox !== state.checkbox) {
        state.checkbox = checkbox;
        if (checkbox.checked !== state.checked) checkbox.click();
      }
    } finally {
      syncing = false;
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }
  function start() {
    if (!document.querySelector(styleSelector)) return;
    document.addEventListener('change', event => {
      if (syncing || !(event.target instanceof Element)) return;
      if (event.target.matches(offerSelector + ' .axe-select')) {
        state.value = event.target.value;
        state.pack = packOf(event.target.selectedOptions[0]) || state.pack;
        state.select = event.target;
      } else if (event.target.matches(offerSelector + ' .axe-input')) {
        state.checked = event.target.checked;
        state.checkbox = event.target;
      } else if (event.target.matches('input[name^="Box Style-"][name$="-9058428158070"]')) {
        sync();
      }
      schedule();
    }, true);
    document.addEventListener('variant:selected', schedule);
    document.addEventListener('variant:update', schedule);
    document.addEventListener('popstate', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('load', schedule);
    document.addEventListener('submit', sync, true);
    new MutationObserver(schedule).observe(document.querySelector('#MainContent') || document.body, {
      childList: true, subtree: true
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["obd-sleeve-addon"] && !Shopify.designMode) return;
  try {
    const previousUpcartHandler = window.upcartShouldAddToCartContinue;
  window.upcartShouldAddToCartContinue = function(event) {
    const form = event?.target instanceof Element
      ? event.target.closest('product-form-component[data-product-id="8035722788982"]')
      : null;
    if (form?.querySelector('[data-obd-sleeve-addon]:checked:not(:disabled)')) return false;
    return typeof previousUpcartHandler === 'function' ? previousUpcartHandler.call(this, event) : true;
  };
  } catch(e) { console.error(e); }
})();

})();
